import { render, staticRenderFns } from "./nav-view.vue?vue&type=template&id=ce025ed0&"
import script from "./nav-view.vue?vue&type=script&lang=ts&"
export * from "./nav-view.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports